// src/components/Dronecontact/Dronecontact.jsx
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import { FiArrowRight, FiNavigation, FiAward, FiFilm, FiCheck } from 'react-icons/fi';
import './Dronecontact.css';

const Dronecontact = () => {
  const navigate = useNavigate();

  const services = [
    { icon: FiNavigation, text: "Flight Planning" },
    { icon: FiAward, text: "FAA Clearances" },
    { icon: FiFilm, text: "Color Grading" },
    { icon: FiCheck, text: "Quality Assurance" }
  ];

  return (
    <section className="dc">
      {/* Enhanced Background Elements */}
      <div className="dc__bg-pattern"></div>
      <div className="dc__floating-elements">
        <div className="dc__floating-element dc__floating-element--1"></div>
        <div className="dc__floating-element dc__floating-element--2"></div>
        <div className="dc__floating-element dc__floating-element--3"></div>
      </div>

      <div className="dc__container">
        {/* Services Badge */}
        <motion.div 
          className="dc__services"
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, ease: "easeOut" }}
          viewport={{ once: true }}
        >
          {services.map((service, index) => {
            const IconComponent = service.icon;
            return (
              <motion.div 
                key={index}
                className="dc__service-item"
                whileHover={{ scale: 1.05, y: -2 }}
                transition={{ type: "spring", stiffness: 300 }}
              >
                <IconComponent className="dc__service-icon" />
                <span>{service.text}</span>
              </motion.div>
            );
          })}
        </motion.div>

        {/* Main Content */}
        <motion.div
          className="dc__content"
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, ease: "easeOut" }}
          viewport={{ once: true, margin: "-100px" }}
        >
          <motion.p 
            className="dc__text"
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.1, ease: "easeOut" }}
            viewport={{ once: true, margin: "-100px" }}
          >
            We manage everything from <span className="dc__text-highlight">meticulous flight planning</span> and 
            <span className="dc__text-highlight"> FAA clearances</span> to <span className="dc__text-highlight">cinematic 
            color grading</span>, ensuring your drone-captured visuals wow stakeholders and audiences everywhere
          </motion.p>

          {/* Enhanced CTA Section */}
          <motion.div
            className="dc__cta-wrapper"
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.3, ease: "easeOut" }}
            viewport={{ once: true, margin: "-100px" }}
          >
            <motion.button
              className="dc__btn"
              onClick={() => navigate('/contact')}
              whileHover={{ 
                y: -4,
                transition: { type: "spring", stiffness: 400, damping: 10 }
              }}
              whileTap={{ scale: 0.98 }}
            >
              <span className="dc__btn-text">Contact Us</span>
              <div className="dc__btn-icon-wrapper">
                <FiArrowRight className="dc__btn-icon" />
              </div>
              <div className="dc__btn-hover-effect"></div>
              <div className="dc__btn-glow"></div>
            </motion.button>

            {/* Trust Indicators */}
            <motion.div 
              className="dc__trust-indicators"
              initial={{ opacity: 0 }}
              whileInView={{ opacity: 1 }}
              transition={{ duration: 0.6, delay: 0.5 }}
              viewport={{ once: true }}
            >
              <div className="dc__trust-item">
                <div className="dc__trust-dot"></div>
                <span>Professional Grade Equipment</span>
              </div>
              <div className="dc__trust-item">
                <div className="dc__trust-dot"></div>
                <span>4K Resolution Guarantee</span>
              </div>
            </motion.div>
          </motion.div>
        </motion.div>
      </div>
    </section>
  );
};

export default Dronecontact;
